import { useEffect } from 'react'

import { useTypedDispatch, useTypedSelector } from '../../..'
import { fetchSuggestedAmendCommentAction } from '../../../actions/defectAssistant'
import { selectCreateDefectAssistantState } from '../../../reducers/createDefectAssistantSlice'

/**
 * The comment proposed for adding to the matched duplicate defect. Comes either inline on the
 * matched defect or, when streamed, is fetched by its suggestedCommentId as soon as the match is known.
 */
export const useSuggestedAmendComment = (): { comment: string | null; loading: boolean } => {
  const dispatch = useTypedDispatch()
  const { questionAnswers, suggestedAmendCommentById } = useTypedSelector(
    selectCreateDefectAssistantState
  )
  const matchedDefect = questionAnswers.find((qna) => qna.matchedDefect)?.matchedDefect
  const commentId = matchedDefect?.suggestedCommentId
  const fetched = commentId ? suggestedAmendCommentById[commentId] : undefined

  useEffect(() => {
    if (!commentId || fetched) return
    void dispatch(fetchSuggestedAmendCommentAction({ suggestedCommentId: commentId }))
  }, [commentId, dispatch, fetched])

  return {
    comment: matchedDefect?.suggestedComment || fetched?.text || null,
    loading: fetched?.status === 'loading',
  }
}
